module.exports = __webpack_public_path__ + "img/tech5.1ab96b6a.webp";